(function($) {
  var serviceDeailsAccordion = $('#serviceDetailAccordion');
  var currentBreakpointSize;

  var smallBreakpointSizes = [ 'small' ];


  // on window load function
  $(document).ready(function(){
    console.log('onload');
    //toogleAccordion();
  });

  $('#testbutton').click(function(){
    $('.serviceDeailsAccordion').foundation('destroy');
    $('.serviceDeailsAccordion').removeClass('accordion');
  });

  function toogleAccordion(){

    if (Foundation.MediaQuery.atLeast('medium')) {
      $('#serviceDetailAccordion').foundation('destroy');

    }else{
    }

  }



})( jQuery );
